<template>

  <div class="order-logistics-back">

    <!--<div class="nav_bar clear_both">-->
      <!--<button class="fl nav_bar_left_item" >-->
        <!--<img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" >-->
      <!--</button>-->
      <!--<div class="order-bar-title">-->
        <!--物流详情-->
      <!--</div>-->
    <!--</div>-->

    <!--商品部分-->
    <div class="order-goods-part">

      <div class="order-goods">
        <!--<div class="order-goods-left">-->
          <!--<van-image src="" fit="cover">-->
            <!--<template v-slot:error></template>-->
          <!--</van-image>-->
        <!--</div>-->
        <div class="order-goods-right" v-if="orderLog">
          <div>物流状态:{{orderLog.logisticsStatus}}</div>
          <div>快递公司:{{orderLog.logisticsCompany}}</div>
          <div>快递单号:{{orderLog.logisticsNo}}</div>
          <div>官方电话:{{orderLog.LogisticsPhone}}</div>
        </div>
      </div>

    </div>

    <!--物流部分-->
    <div class="order-logistics-part" v-if="orderLog">
      <div class="order-logistics-each" v-for="(detail,index) in orderLog.data" v-if="index==0" >
        <div class="order-logistics-each-left">
          <img src="@/images/circle1@3x.png" class="order-logistics-status-icon"/>
        </div>
        <div class="order-logistics-each-right">
          <div class="order-logistics-time">
            {{detail.time}}
          </div>
          <div class="order-logistics-desc">
            {{detail.context}}
          </div>
        </div>
      </div>
      <div class="order-logistics-each" v-for="(detail,index) in orderLog.data" v-if="index!=0" >
        <div class="order-logistics-each-left">
          <img src="@/images/circle2@3x.png" class="order-logistics-status-icon2"/>
          <div class="order-logistics-line"></div>
        </div>
        <div class="order-logistics-each-right">
          <div class="order-logistics-time">
            {{detail.time}}
          </div>
          <div class="order-logistics-desc">
            {{detail.context}}
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>

  import Vue from 'vue'
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getOrderLogistics } from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';

  export default {
    name: "orderLogistics",
    data() {
      return {
        showLoading: true,
        orderId: this.$route.query.orderId,
        shipmentId: this.$route.query.shipmentId,
        orderLog:{},
        token:getStore('externalLoginKey'),
      }
    },

    mounted(){
      this.initData()
      document.documentElement.scrollTop = 0
    },

    methods:{

      async initData() {
        this.getLog();
      },

      getLog:function () {
        let params = {
          orderId:this.orderId,
          shipmentId:this.shipmentId,
          externalLoginKey:this.token
        }
        getOrderLogistics(params)
          .then(res => {
            console.log(res);
            if(res._ERROR_MESSAGE_!=undefined||res._ERROR_MESSAGE_!=''){
              this.orderLog = res.resultMap
              if(!this.orderLog){
                Toast('暂未查询到快递信息')
                if(!this.orderLog.data){
                  Toast('暂未查询到物流信息')
                }
              }
            }else{
              Toast(res._ERROR_MESSAGE_)
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //用户取消订单
      goCanel:function (orderId) {
        Dialog.confirm({
          title: '取消订单',
          message: '确认要取消该订单吗?'
        }).then(() => {
          let params = {
            productStoreId:this.productStoreId,
            orderId:orderId,
            externalLoginKey:this.token
          }
          orderCancel(params)
            .then(res => {
              console.log(res);
              if(res._EVENT_MESSAGE_!=undefined||res._EVENT_MESSAGE_!=null){
                Toast(res._EVENT_MESSAGE_)
              }else{
                Toast('取消订单成功')
              }
            })
            .catch(err => {
              console.log(err);
            });
        }).catch(() => {
          // on cancel
        });

      },
      //用户确认收货
      goSure:function (orderId,shipmentId) {
        Dialog.confirm({
          title: '确认收货',
          message: '确认收到该宝贝了吗?'
        }).then(() => {
          let params = {
            productStoreId:this.productStoreId,
            orderId:orderId,
            externalLoginKey:this.token,
            shipmentId:shipmentId
          }
          confirmOrderRecive(params)
            .then(res => {
              console.log(res);
              if(res._ERROR_MESSAGE_!=undefined){
                Toast(res._ERROR_MESSAGE_)
              }else{
                Toast('确认收货成功')
              }
            })
            .catch(err => {
              console.log(err);
            });
        }).catch(() => {
          // on cancel
        });
      },
      //用户查看物流
      goLog:function (orderId) {
        this.$router.push({name:'orderLogistics',query:{oderId:orderId}})
      }
    }
  }
</script>

<style scoped>
  .order-logistics-back{
    background-color: #F8F8F8;
    position: absolute;
    top: 0;
    width:100%;
  }
  .nav_bar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    position: fixed;
    z-index: 99;
    width: 100%;
    background: white;
    opacity: 1;
    border-bottom: 1px solid #E1E1E1;
  }
  .nav_bar_left_item {
    padding-top: 0.3rem;
    width:3rem;
  }
  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }
  .order-bar-title{
    width:calc(100% - 3rem);
    text-align: center;
    font-size: 1rem;
    color:#333312;
    height: 2rem;
    line-height: 2rem;
  }
  .order-goods-part{
    width:100%;
    background-color: white;
    /*padding-top: 3rem;*/
    margin-bottom:0.625rem;
  }
  .order-goods{
    width:21.4375rem;
    margin: 0 auto;
    padding: 0.9375rem 0;
    border-bottom: 1px solid #E6E6E6;
  }
  .order-goods-left{
    display: inline-block;
    vertical-align: top;
    width:5.625rem;
    height: 5.625rem;
    margin-right: 0.75rem;
  }
  .order-goods-left .van-image{
    width:100%;
    height: 100%;
  }
  .order-goods-right{
    display: inline-block;
    vertical-align: top;
  }
  .order-goods-right div{
    color:#333312;
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
  }
  .order-logistics-part{
    width:100%;
    background-color: white;
    padding-top: 1rem;
  }
  .order-logistics-each{
    width:21.4375rem;
    margin: 0 auto 0.625rem;
  }
  .order-logistics-each-left{
    display: inline-block;
    vertical-align: top;
    width:1rem;
    margin-right:1.53125rem;
    height: 5rem;
  }
  .order-logistics-status-icon{
    width:1.09375rem;
    height: 1.09375rem;
  }
  .order-logistics-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3rem);
    min-height: 3.75rem;
  }
  .order-logistics-time{
    color:#9E9E9E;
    font-size: 0.625rem;
    margin-bottom: 0.5rem;
  }
  .order-logistics-desc{
    font-size:0.84375rem;
    color:#666666;
  }
  .order-logistics-status-icon2{
    width:0.75rem;
    height: 0.75rem;
    margin-left: 0.1rem;
  }
  .order-logistics-line{
    height: 3.5rem;
    width:1rem;
    border-left: 1px solid #E7E7E7;
    position: relative;
    left: 0.5rem;
    top: -5rem;
  }




</style>



// WEBPACK FOOTER //
// src/components/page/mine/orderLogistics.vue